



















import { Component, Prop, Vue } from 'vue-property-decorator';
import { Action, Mutation, State } from 'vuex-class';
import { RootState } from '@/store/types';
import Store from '@/store/store';

const namespace: string = 'login';

@Component
export default class SideBar extends Vue {
  @Action('logout', { namespace }) private logout?: () => void;
  @State('menuVisible') private menuVisible: boolean;
  @Mutation('closeMenu') private closeMenu: () => void;
}
